export default "__VITE_ASSET__7191285e__"